import { number } from 'prop-types'
import { createSelector } from 'reselect'

// @ts-ignore
import { secondRoutePieceAsInt } from 'store/entities/router/selectors'
import { ICompletedProtracksRecord } from './interface'

export const getCompletedProtracks = (state: any): ICompletedProtracksRecord => state.get('completedProtracks')

export const getCompletedProtracksPending = createSelector(getCompletedProtracks, state => state.get('pending'))

export const getCompletedLevelsList = createSelector(getCompletedProtracks, state => state.get('levelsList'))

export const getCompletedProtrackActivitiesList = createSelector(getCompletedProtracks, state =>
  state.get('activitiesList')
)

export const getCompletedProtrackPagination = createSelector(getCompletedProtracks, state => state.get('pagination'))

export const getCompletedProtrackPaginationCount = createSelector(getCompletedProtrackPagination, pagination =>
  pagination.get('count')
)

export const getCompletedProtrackPaginationPerPage = createSelector(getCompletedProtrackPagination, pagination =>
  pagination.get('perPage')
)

export const getCompletedProtrackPaginationCurrent = createSelector(getCompletedProtrackPagination, pagination =>
  pagination.get('current')
)

export const getCompletedProtrackPaginationShow = createSelector(getCompletedProtrackPagination, pagination =>
  pagination.get('show')
)

export const getViewCompletedLevel = createSelector([getCompletedLevelsList, secondRoutePieceAsInt], (levels, id) =>
  levels.find(el => el.get('id') === id)
)

export const getCompletedProtrackPaginationPagesAmount = createSelector<
  Partial<ICompletedProtracksRecord>,
  any,
  any,
  number
>(getCompletedProtrackPaginationCount, getCompletedProtrackPaginationPerPage, (amount, perPage) =>
  Math.ceil(amount / perPage)
)

export const getCompletedProtracksforCurrentPage = createSelector<
  Partial<ICompletedProtracksRecord>,
  any,
  any,
  any,
  any
>(
  getCompletedLevelsList,
  getCompletedProtrackPaginationCurrent,
  getCompletedProtrackPaginationPerPage,
  (all, currentPage, perPage) => all.skip(currentPage * perPage).take(perPage)
)
